import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '@shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class TemplateDetailsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);
  private router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | UrlTree {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    const projectName = this.systemService.getSelectedProject();

    // Add query parameter to URL if not present
    if (projectName && !route.queryParams['project']) {
      return this.router.createUrlTree([`/templates/${uuid}`], {
        queryParams: { project: projectName },
      });
    }

    const view = this.getView(route);
    if (view) {
      return this.routeGuardService.handleRoute(view, route);
    }
    return Promise.resolve(true);
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    const projectName = this.systemService.getSelectedProject();
    const iframeUrl = projectName
      ? `template/${uuid}?project=${projectName}`
      : `template/${uuid}`;

    return {
      route: `templates/${uuid}`,
      iframeUrl,
    };
  }
}
